import axios, { AxiosRequestConfig } from "axios";
import { ref } from "vue";
import { EnvironmentSettings } from "../constants";

export const useApi = (url: string) => {
    const loading = ref(false);
    const data = ref();
    const error = ref();

    const api = axios.create({
        baseURL: EnvironmentSettings.ApiUrl,
    });

    const get = <T>(
        id?: number | string,
        query?: Record<string, string | number | boolean>,
        config?: AxiosRequestConfig,
    ): Promise<T> => {
        loading.value = true;
        error.value = undefined;

        let queryString = '';

        if (query) {
            queryString = '?' + Object.entries(query)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
        }

        let completeUrl = url;
        if (id) {
            completeUrl += '/' + id;
        }

        return api.get<T>(completeUrl + queryString, config)
            .then(response => {
                data.value = response.data;
                return response.data as T;
            })
            .catch(e => {
                error.value = e;
                throw e;
            })
            .finally(() => loading.value = false);
    };

    const post = <T>(
        payload: Record<string, string | number | boolean | object>,
        config?: AxiosRequestConfig,
    ): Promise<T> => {
        loading.value = true;
        error.value = undefined;

        return api.post<T>(url, payload, config)
            .then(response => {
                data.value = response.data;
                return response.data as T;
            })
            .catch(e => {
                error.value = e;
                throw e;
            })
            .finally(() => loading.value = false);
    };

    return {
        data,
        loading,
        error,
        get,
        post,
    };
};
